var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    stroke: "white",
    strokeWidth: 2,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5813 6.30426C13.771 6.51462 14.0409 6.63471 14.3241 6.63471C14.6073 6.63471 14.8772 6.51462 15.0669 6.30426C17.3592 3.76122 21.0476 3.15564 23.8948 5.4012C26.765 7.66483 27.1035 11.467 24.8981 14.16C23.8917 15.3888 21.8098 17.3571 19.663 19.2799C17.536 21.1849 15.4091 22.9894 14.3581 23.8725C14.3462 23.8825 14.3349 23.8921 14.3241 23.9011C14.3133 23.8921 14.302 23.8826 14.2901 23.8725L14.1412 24.0497L14.2901 23.8725C13.2391 22.9894 11.1122 21.1849 8.98526 19.2799C6.83841 17.3571 4.75647 15.3888 3.75013 14.16C1.55418 11.4786 1.92508 7.69442 4.76389 5.39278C7.5446 3.13827 11.2817 3.75317 13.5813 6.30426Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLike);
export default __webpack_public_path__ + "static/media/icon-like.963d11f0a2a005f5ecf94e02c7413ee9.svg";
export { ForwardRef as ReactComponent };